import { useMutation } from "@tanstack/react-query";
import client from "api/graphql/getClient";
import { graphql } from "gql/gql";
import { CreateResetPasswordRequestParams } from "gql/graphql";
import { useActiveAccount } from "utils/useActiveAccount";

const createResetPasswordRequestDocument = graphql(/* GraphQL */ `
	mutation createResetPasswordRequest(
		$params: CreateResetPasswordRequestParams!
	) {
		createResetPasswordRequest(params: $params) {
			error {
				code
				message
			}
			success
		}
	}
`);

interface Args {
	params: CreateResetPasswordRequestParams;
	userId?: string;
}

const createResetPasswordRequest = ({ params, userId }: Args) =>
	client(userId)
		.request(createResetPasswordRequestDocument, { params })
		.then((res) => res.createResetPasswordRequest);

const useCreateResetPasswordRequest = () => {
	const { userId } = useActiveAccount();

	return useMutation((params: CreateResetPasswordRequestParams) =>
		createResetPasswordRequest({ params, userId })
	);
};

export default useCreateResetPasswordRequest;
